import { css } from 'styled-components';

const sizes = {
  ultraGiant: 1250,
  giant: 992,
  desktop: 768,
  tablet: 480
};

export const media = Object.keys(sizes).reduce((accumulator, label) => {
  const emSize = sizes[label] / 16;
  accumulator[label] = (...args) => css`
    @media (min-width: ${emSize}em) {
      ${css(...args)};
    }
  `;
  return accumulator;
}, {});



// WEBPACK FOOTER //
// ./src/utils/style.js